import React from 'react';
import Route from 'react-router-dom/Route';
import Header from './Header';

const SimpleLayout = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={matchProps => (
                <div>
                    <Header location={matchProps.location} />

                    <div>
                        <Component {...matchProps} />
                    </div>
                </div>
            )}
        />
    );
};

export default SimpleLayout;



// WEBPACK FOOTER //
// ./app/web/src/layout/Simple.jsx